const solarstrom = function () {
  
  function initLightbox() {
    let lightboxen = document.querySelectorAll('.lightbox');
    lightboxen.forEach(lightbox => {
      lightbox.addEventListener('click', function () {
        let img = this.querySelector('img');
        let src = img.getAttribute('src');
        let alt = img.getAttribute('alt');
        let lightbox = document.createElement('div');
        lightbox.classList.add('lightbox-overlay');
        let lightboxImg = document.createElement('img');
        lightboxImg.setAttribute('src', src);
        lightboxImg.setAttribute('alt', alt);
        lightbox.appendChild(lightboxImg);
        document.body.appendChild(lightbox);
        lightbox.addEventListener('click', function () {
          document.body.removeChild(lightbox);
        });
      });
    });
  }

  initLightbox();


};

export default solarstrom;



// WEBPACK FOOTER //
// ./scripts/barba-views/solarstrom.js